import { redirect, RouteObject } from "react-router-dom";
import { Layout } from "../Layout/Layout";
import React from "react";

const FortuneWheelPage = React.lazy(
  async () => await import("../Pages/FortuneWheel_V2/FortuneWheelPage")
);
const FourtuneWheelProfilePage = React.lazy(
  async () => await import("../Pages/FortuneWheel_V2/Profile/ProfilePage")
);
const FortuneWheelBonusPage = React.lazy(
  async () => await import("../Pages/FortuneWheel_V2/Bonus/BonusPage")
);

const WheelDatabasePage = React.lazy(
  async () => await import("../Pages/FortuneWheel_V2/Database/DatabasePage")
);

export const RouterFortuneWheel: RouteObject[] = [
  {
    path: "/game/fortuneWheel/",
    loader: async () => {
      // Здесь вы можете получить значение :table из базы данных
      const table = "database";
      return redirect(`/game/fortuneWheel/${table}`);
    },
  },
  {
    path: "/game/fortuneWheel/:table/",
    element: (
      <Layout>
        <FortuneWheelPage />
      </Layout>
    ),
  },
  {
    path: "/game/fortuneWheel/bonus/create",
    element: (
      <Layout>
        <FortuneWheelBonusPage />
      </Layout>
    ),
  },
  {
    path: "/game/fortuneWheel/bonus/:id",
    element: (
      <Layout>
        <FortuneWheelBonusPage />
      </Layout>
    ),
  },
  {
    path: "/game/fortuneWheel/bonuses/create",
    loader: async () => {
      return redirect(`/game/fortuneWheel/bonus/create`);
    },
  },
  {
    path: "/game/fortuneWheel/bonus/",
    loader: async () => {
      return redirect(`/game/fortuneWheel/bonuses/`);
    },
  },
  {
    path: "/game/fortuneWheel/profile/create",
    element: (
      <Layout>
        <FourtuneWheelProfilePage />
      </Layout>
    ),
  },
  {
    path: "/game/fortuneWheel/profiles/create",
    loader: async () => {
      return redirect(`/game/fortuneWheel/profile/create`);
    },
  },
  {
    path: "/game/fortuneWheel/profile/",
    loader: async () => {
      return redirect(`/game/fortuneWheel/profiles/`);
    },
  },
  {
    path: "/game/fortuneWheel/profile/:id/",
    loader: async ({ params }) => {
      const tab = "global";
      return redirect(`/game/fortuneWheel/profile/${params.id}/${tab}`);
    },
  },
  {
    path: "/game/fortuneWheel/profiles/:id/",
    loader: async ({ params }) => {
      const tab = "global";
      return redirect(`/game/fortuneWheel/profile/${params.id}/${tab}`);
    },
  },
  {
    path: "/game/fortuneWheel/profile/:id/:tab",
    element: (
      <Layout>
        <FourtuneWheelProfilePage />
      </Layout>
    ),
  },
  {
    path: "/game/fortuneWheel/database/create",
    element: (
      <Layout>
        <WheelDatabasePage />
      </Layout>
    ),
  },
  {
    path: "/game/fortuneWheel/database/:id/",
    loader: async ({ params }) => {
      const tab = "global";
      return redirect(`/game/fortuneWheel/database/${params.id}/${tab}`);
    },
  },
  {
    path: "/game/fortuneWheel/database/:id/:tab/",
    element: (
      <Layout>
        <WheelDatabasePage />
      </Layout>
    ),
  },
];
